import { render, staticRenderFns } from "./edit-icon-renderer.vue?vue&type=template&id=b180406e&scoped=true"
import script from "./edit-icon-renderer.vue?vue&type=script&lang=js"
export * from "./edit-icon-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b180406e",
  null
  
)

export default component.exports